module.exports = __webpack_public_path__ + "img/querzugkraft.60909062.svg";